<template>
  <transition name="fade" enter-active-class="zoomInLeft" leave-active-class="zoomOutRight">
    <section class="mask_container animated" v-show="visible">
       <div class="player">
         <i class="el-icon-circle-close btn-close" @click="closePlay"></i>
          <video-player class="video-player vjs-custom-skin" ref = "videoPlayer"
          :playsinline="false"
          :options="playerOptions"
           @play="onPlayerPlay($event)"
           @pause="onPlayerPause($event)"
           @statechanged="playerStateChanged($event)"
          ></video-player>
         <div class="videoInfo" v-if="!!datainfo1">
           <div class="videoTitel">{{datainfo1.title}}</div>
           <div class="data">{{datainfo1.videoDate}}</div>
           <div class="eTiele">{{datainfo1.content}}</div>
         </div>
       </div>
    </section>
  </transition>
</template>

<script>
  import { videoPlayer } from 'vue-video-player'
  import 'video.js/dist/video-js.css'
  import 'vue-video-player/src/custom-theme.css'
    export default {
        name: "Vplayer",
        props:{
          isShow: Boolean,
          datainfo:Object
        },
        component:{
           videoPlayer
         },
        mounted(){
          this.datainfo1 = this.datainfo;
          this.visible = this.isShow;

          let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;


        },
         data(){
          return{
            visible: false,
            datainfo1:null,
            playerOptions: {
               //playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
               autoplay: true,  //自动播放
               muted: false, // 默认情况下将会消除任何音频
               preload: 'auto',
               language: 'zh-CN',
               aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
               fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
               sources: [{
                  type: 'video/mp4',
                  src: this.datainfo.videoUrl// 你的m3u8地址（必填）
               }],
              width: document.documentElement.clientWidth,
              notSupportedMessage: '此视频暂无法播放，请稍后再试'// 允许覆盖Video.js无法播放媒体源时显示的默认信息。
            }
          }
         },
        watch:{
          'datainfo':{
            handler(newVideoUrl, oldvideoUrl) {
              this.$set(this, 'datainfo1', this.datainfo);
              // this.isShow = this.datainfo.state || false;
            },
            deep: true
          },
          'datainfo.videoUrl':{
            handler(newVideoUrl, oldvideoUrl) {
              if(newVideoUrl !=='') {
                this.$refs.videoPlayer.player.src(newVideoUrl);
              }
            }
          },
          isShow(n, o){
            this.visible = n
          },
          // deep: true,
          // immediate: true
        },
      methods:{
        closePlay(){
          this.visible = false;
          this.$refs.videoPlayer.player.pause();
          this.$emit('close');
        },
        onPlayerPlay(player){

        },
        onPlayerPause(player){

        },
        playerStateChanged(player){

        }
      },
      computed:{
        player(){
          return this.$refs.videoPlayer.player;
        }
      }
    }
</script>

<style scoped lang="less">
   .mask_container{
      background-color: rgba(100,100 ,100,.5);
      min-height: 100%;
      position: fixed;
      top:0px;
      left:0px;
       bottom:0px;
       right:0px;
      width: 100%;
      height: 100%;
      transition: background .5s;
      z-index: 9999999999999999;
     overflow: hidden;
     .player{
        width: 750px;
        position: absolute;
        top:50%;
        left:50%;
        margin-left: -395px;
        margin-top: -280px;
        background-color: #fff;
        padding: 20px;
     }
     .videoInfo{
        height: 50px;
     }
     .videoTitel{
       font-size:22px;
       font-weight:400;
       color:rgba(51,51,51,1);
       line-height:14px;
       text-align: left;
        margin-top:30px;
     }
       .eTiele{
         font-size:16px;
         font-weight:400;
         color:rgba(153,153,153,1);
         line-height:20px;
         text-align: left;
       }
       .data{
         font-size:16px;
         font-weight:400;
         color:rgba(153,153,153,1);
         line-height:20px;
         text-align: right;
       }
     .btn-close{
        width: 16px;
        height: 16px;
        font-size: 30px;
        position: absolute;
        top:0px;
        right: -40px;
        color: #fff;
     }
   }

   .fade-enter-active, .fade-leave-active {
     transition: opacity .5s
   }
   .fade-enter, .fade-leave-active {
      opacity: 0;
      transition: opacity 3s;
   }

   .player.on{

   }
</style>
